/**
 * swisspostsolutionscms - JSON API
 * This is a JSON API compliant implementation
 *
 * The version of the OpenAPI document: Versioning not supported
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParagraphNewsTickerItemSchemaLinksValue } from './paragraphNewsTickerItemSchemaLinksValue';
import { ParagraphRelatedItemsDataRelationships } from './paragraphRelatedItemsDataRelationships';
import { ParagraphRelatedItemsDataAttributes } from './paragraphRelatedItemsDataAttributes';


/**
 * \\\"Resource objects\\\" appear in a JSON:API document to represent resources.
 */
export interface ParagraphRelatedItemsData { 
    relationships?: ParagraphRelatedItemsDataRelationships;
    /**
     * Non-standard meta-information that can not be represented as an attribute or relationship.
     */
    meta?: object;
    attributes?: ParagraphRelatedItemsDataAttributes;
    links?: { [key: string]: ParagraphNewsTickerItemSchemaLinksValue; };
    id: string;
    /**
     * Resource type
     */
    type: ParagraphRelatedItemsData.TypeEnum;
}
export namespace ParagraphRelatedItemsData {
    export type TypeEnum = 'paragraph--related_items';
    export const TypeEnum = {
        ParagraphRelatedItems: 'paragraph--related_items' as TypeEnum
    };
}


